// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .backgroundImage--SdGRW {
  background-image: url('/dist/src/img/backgrounds/grey_background.png');
  background-size: cover;
  padding-bottom: 70px;
}

.backgroundWhite--75XO5 {
  position: relative;
}

[dir] .backgroundWhite--75XO5 {
  background-color: white;
  border-radius: 14px;
}

.backgroundOffWhite--doX_2 {
  position: relative;
  overflow: auto;
}

[dir] .backgroundOffWhite--doX_2 {
  background-color: #f9f7f5;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/Data/styles.css"],"names":[],"mappings":"AAAA;EACE,sEAAsE;EACtE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EAEE,kBAAkB;AAEpB;;AAJA;EACE,uBAAuB;EAEvB,mBAAmB;AACrB;;AAEA;EAEE,kBAAkB;EAClB,cAAc;AAEhB;;AALA;EACE,yBAAyB;EAGzB,oBAAoB;AACtB","sourcesContent":[".backgroundImage {\n  background-image: url('/dist/src/img/backgrounds/grey_background.png');\n  background-size: cover;\n  padding-bottom: 70px;\n}\n\n.backgroundWhite {\n  background-color: white;\n  position: relative;\n  border-radius: 14px;\n}\n\n.backgroundOffWhite {\n  background-color: #f9f7f5;\n  position: relative;\n  overflow: auto;\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundImage": `backgroundImage--SdGRW`,
	"backgroundWhite": `backgroundWhite--75XO5`,
	"backgroundOffWhite": `backgroundOffWhite--doX_2`
};
export default ___CSS_LOADER_EXPORT___;
